import CloseIcon from '@material-ui/icons/Close';
import utils from '../../utils/utils';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useStyles } from 'component/style_item/style';
import clsx from 'clsx';
import { Swiper, SwiperSlide } from 'swiper/react';
import StandardLabelTag from 'component/StandardLabelTag';
import { useDoubleTap } from 'use-double-tap';
import { setTrackingData } from '../../redux/analytic/analytic.slice';
import { getProductTrackingData } from '../../utils/trackUtils';
import { RootState, useAppDispatch, useAppSelector } from '../../redux/store';
import './dynamic_item_detail.scss';
import { PATH } from '../../routes/constant';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { dynamicLayoutItemDetailStyle } from './style';
import { ReactionType, STRINGS } from '../../constants';
import { Currency } from '../user_reactions/types';
import config from '../../config';
import { ReactComponent as DislikeFill } from '../../assets/svg/disliked_old.svg';
import { ReactComponent as BtnDislike } from '../../assets/svg/dislike_old.svg';
import { ReactComponent as EditStyle } from '../../assets/svg/edit_style.svg';
import { ReactComponent as OpenNewTab } from 'assets/svg/open-new-tab.svg';
import { ReactComponent as BtnLikeFill } from '../../assets/svg/like_fill_v2.svg';
import { ReactComponent as BtnLike } from '../../assets/svg/like_v2.svg';
import { ReactComponent as BtnShare } from '../../assets/svg/share_v2.svg';
import { ReactComponent as FeedBack } from '../../assets/svg/feedback.svg';
import { ReactComponent as FeedBackView } from '../../assets/svg/feedback-view.svg';
import UserType from 'constants/user';
import { PRODUCT_TYPE, TRACK_EVENT, trackEvent } from '../../utils/analytics';
import { useMutation } from '@apollo/client';
import { CREATE_TRACK_SHOP_THE_ITEM } from 'graph_ql/track_shop_the_item/mutations';
import { useSelector } from 'react-redux';
import { useUrlQuery } from 'hooks/useUrlQuery';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import themes from '../../styles/themes';
import millify from 'millify';
import classnames from 'classnames';
import { FEEDBACK_TRIGGER_TYPE } from 'component/style_item/type';
import { useVisualViewport } from '../../utils/useVisaulViewport';
import Drawer from '@material-ui/core/Drawer';
import ZoomImage from 'component/zoom_image';
import WidgetPopup from 'component/popup/customize_popup';
import { WidgetCode } from 'component/popup/constant';
import styleItemUtils from '../../utils/style_item';
import { pick } from 'lodash';
const blankImage = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';

interface IDynamicLayoutItemDetailProps {
    item: any;
    style?: any;
    handleClose?: any;
    userDetail?: any;
    reaction?: any;
    toggleReactionLoading?: any;
    handleReaction?: any;
    handleViewFeedbackByStylist?: any;
    handleOpenFeedback?: any;
    feedback?: any;
    setSharing?: any;
    getShareImage?: any;
    showItemInfoButton?: boolean;
}

const DynamicLayoutItemDetail = ({
    item,
    style,
    handleClose,
    userDetail,
    toggleReactionLoading,
    handleReaction,
    reaction,
    handleViewFeedbackByStylist,
    handleOpenFeedback,
    feedback,
    setSharing,
    getShareImage,
    showItemInfoButton = true,
}: IDynamicLayoutItemDetailProps) => {
    const styleItemStyles = useStyles();
    const dynamicLayoutItemDetailStyles = dynamicLayoutItemDetailStyle();
    const dispatch = useAppDispatch();
    const history = useHistory();
    const location: any = useLocation();
    const searchQuery = useUrlQuery();
    const [createTrackShopTheItem] = useMutation(CREATE_TRACK_SHOP_THE_ITEM);
    const storeId = useAppSelector((state: RootState) => state.widget.store?.id);
    const taffiStoreId = useSelector((state: RootState) => state.global.taffiStoreId);
    const storeSourceUrl = useSelector((state: RootState) => state.widget?.sourceUrl);
    const taffiId = style?.taffiId;
    const { userName } = useParams<{ userName: string }>();
    const isCustomer = Boolean(userDetail && userDetail.userType === UserType.Customer);
    const url = useMemo(() => {
        if ((utils.isAppInWidgetMode() && storeSourceUrl?.length > 0) || !utils.isAppInWidgetMode()) {
            return utils.getShareEntityUrlWithParams('/item', item?.taffiId, `styleTaffiId=${taffiId}`, taffiId);
        }
        return null;
    }, [storeSourceUrl, taffiId, item?.taffiId]);
    const priceRef = useRef<HTMLDivElement>(null);
    const itemHeaderRef = useRef<HTMLDivElement>(null);
    const [imageToEnlarge, setImageToEnlarge] = useState<any>(null);
    const [showEnlarge, setShowEnlarge] = useState<any>(null);
    const handleEnlargeImage = (image) => {
        setImageToEnlarge(image);
        setShowEnlarge(true);
    };
    const bind = useDoubleTap((event: any) => {
        dispatch(setTrackingData(getProductTrackingData(userDetail, item, style)));
        handleEnlargeImage(event.target.currentSrc || '');
    });

    const [showPopupInfo, setShowPopupInfo] = useState(false);
    const handleViewInfo = (item) => {
        setShowPopupInfo(true);
        trackEvent(TRACK_EVENT.PRODUCT_INFO_OPEN, getProductTrackingData(userDetail, item, style));
    };

    const pagination = {
        clickable: true,
    };
    const isEditable = Boolean(
        item?.creator === userDetail?.id ||
            (item?.storeId &&
                userDetail?.userType === UserType.Stylist &&
                (userDetail?.stores || []).map((s) => s?.id).includes(item?.storeId)),
    );

    const windowSize = useVisualViewport();
    const [widthTitle, setWidthTitle] = useState(0);
    useEffect(() => {
        const screenWidth = windowSize.viewport.width;
        const temp = itemHeaderRef.current?.offsetWidth || (screenWidth < 1024 ? screenWidth : 1024);
        const priceWidth = priceRef.current?.offsetWidth || 140;
        if (temp) {
            setWidthTitle(temp - priceWidth);
        }
    }, [windowSize, item, priceRef, itemHeaderRef]);

    const handleBottomButton = () => {
        if (isEditable) {
            history.push(`${PATH.EDIT_ITEM}/${item?.taffiId}`);
        } else {
            if (item?.currency !== Currency.Sar || config.removeCheckOut) {
                trackEvent(TRACK_EVENT.SHOP_THE_PRODUCT, {
                    product_type: PRODUCT_TYPE.ITEM,
                    contextType: PRODUCT_TYPE.STYLE,
                    contextId: style?.id,
                    contextTaffiId: style?.taffiId,
                    product: pick(item.data, ['id', 'taffiId', 'title', 'price', 'currency', 'url']),
                    recommendationSource: location.pathname,
                });
                if (storeId || taffiStoreId) {
                    createTrackShopTheItem({
                        variables: {
                            input: {
                                itemId: item.id,
                                storeId: storeId || taffiStoreId,
                            },
                        },
                    });
                }
                const itemUrl = new URL(item?.url);
                if (!userDetail) {
                    itemUrl?.searchParams?.append(config.widgetConstants.WIDGET_INITIAL_CLOSED, 'true');
                    let taffiPath = `${PATH.DISCOVER_YOUR_STYLE}?taffiId=${taffiId}`;
                    if (location.pathname === PATH.STYLE_IT_RIGHT) {
                        const sourceProductUrl =
                            location?.state?.sourceProductURL || searchQuery.get('sourceProductUrl');
                        taffiPath = `${PATH.STYLE_IT_RIGHT}?taffiId=${taffiId}&sourceProductUrl=${sourceProductUrl}`;
                    }
                    if (itemUrl?.searchParams.get(config.widgetConstants.TAFFI_PATH)) {
                        itemUrl?.searchParams.set(config.widgetConstants.TAFFI_PATH, taffiPath);
                    } else {
                        itemUrl?.searchParams.append(config.widgetConstants.TAFFI_PATH, taffiPath);
                    }
                } else {
                    if (itemUrl?.searchParams.get(config.widgetConstants.TAFFI_CONTEXT)) {
                        itemUrl?.searchParams.set(config.widgetConstants.TAFFI_CONTEXT, taffiId);
                    } else {
                        itemUrl?.searchParams.append(config.widgetConstants.TAFFI_CONTEXT, taffiId);
                    }
                }
                window.open(itemUrl.href);
            }
        }
    };

    return (
        <>
            <Drawer
                open={Boolean(item)}
                onClose={handleClose}
                anchor="bottom"
                PaperProps={{
                    style: {
                        height: utils.isAppInWidgetMode() ? '80vh' : '100vh',
                        ...(utils.isAppInWidgetMode()
                            ? {
                                borderTopRightRadius: 24,
                                borderTopLeftRadius: 24,
                            }
                            : {}),
                    },
                }}
            >
                <div className={dynamicLayoutItemDetailStyles.wrapper}>
                    <div className={styleItemStyles.styleContainer}>
                        <div
                            ref={itemHeaderRef}
                            className={clsx({
                                [styleItemStyles.styleHeader]: true,
                                [styleItemStyles.borderBottom]: true,
                            })}
                            id="itemHeader"
                        >
                            <div className={styleItemStyles.title} style={{ width: `${widthTitle - 32}px` }}>
                                <p className={styleItemStyles.titleDetail}>{item?.title}</p>
                            </div>
                            <div ref={priceRef} className={dynamicLayoutItemDetailStyles.headerRightSide}>
                                <span className={styleItemStyles.price}>
                                    {utils.getPrice(item?.price as number, item?.currency)}
                                </span>
                                <CloseIcon
                                    className={dynamicLayoutItemDetailStyles.closeIcon}
                                    onClick={() => {
                                        handleClose();
                                    }}
                                />
                            </div>
                        </div>
                        <div
                            style={{
                                position: 'relative',
                                height: 'auto',
                                flex: 1,
                            }}
                        >
                            <div
                                style={{
                                    position: 'relative',
                                    height: utils.isAppInWidgetMode() ? 'calc(100vh - 284px)' : 'calc(100vh - 210px)',
                                    display: 'flex',
                                }}
                            >
                                {Boolean(item?.brand?.name) && (
                                    <span className={styleItemStyles.brandName}>
                                        <StandardLabelTag
                                            label={{
                                                name: item?.brand?.name,
                                                icon: item?.brand?.imageUrl,
                                                background: '#F2F2F2',
                                            }}
                                        />
                                    </span>
                                )}
                                <Swiper pagination={pagination}>
                                    {item?.images.map((image, index) => {
                                        return (
                                            <SwiperSlide key={index}>
                                                <div className={dynamicLayoutItemDetailStyles.itemImageWrapper}>
                                                    <div>
                                                        <img
                                                            src={image ?? blankImage}
                                                            className={styleItemStyles.itemImage}
                                                            style={{
                                                                height: utils.isAppInWidgetMode()
                                                                    ? 'calc(100vh - 280px)'
                                                                    : 'calc(100vh - 240px)',
                                                                maxHeight: 600,
                                                            }}
                                                            alt={item?.title}
                                                            onDoubleClick={() => {
                                                                handleEnlargeImage(image ?? blankImage);
                                                            }}
                                                            {...bind}
                                                        />
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                        );
                                    })}
                                </Swiper>
                                <div
                                    className={styleItemStyles.actions}
                                    style={{
                                        height: '100%',
                                        justifyContent: 'space-between',
                                        right: 0,
                                    }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            flexDirection: 'column',
                                            flex: 1,
                                        }}
                                    >
                                        {showItemInfoButton && (
                                            <span className={styleItemStyles.actionsIcon} onClick={handleViewInfo}>
                                                <InfoOutlinedIcon style={{ color: themes.palette.primary.main }} />
                                            </span>
                                        )}
                                        {isEditable && !userName ? (
                                            <span className="d-flex flex-column align-items-center">
                                                <span className={styleItemStyles.actionsIcon} onClick={() => null}>
                                                    <BtnLikeFill />
                                                </span>
                                                <div className={styleItemStyles.actionStatistic}>
                                                    {millify(reaction?.totalLike)}
                                                </div>
                                            </span>
                                        ) : userDetail && isCustomer ? (
                                            <span
                                                className={classnames(styleItemStyles.actionsIcon, {
                                                    [styleItemStyles.disabled]: toggleReactionLoading,
                                                })}
                                                onClick={() => {
                                                    handleReaction && handleReaction(ReactionType.Like);
                                                }}
                                            >
                                                {reaction?.like ? <BtnLikeFill /> : <BtnLike />}
                                            </span>
                                        ) : null}
                                        {isEditable && !userName ? (
                                            <span className="d-flex flex-column align-items-center">
                                                <span className={styleItemStyles.actionsIcon} onClick={() => null}>
                                                    <DislikeFill style={{ width: 22 }} />
                                                </span>
                                                <div className={styleItemStyles.actionStatistic}>
                                                    {millify(reaction?.totalDislike)}
                                                </div>
                                            </span>
                                        ) : userDetail && isCustomer ? (
                                            <span
                                                className={classnames(styleItemStyles.actionsIcon, {
                                                    [styleItemStyles.disabled]: toggleReactionLoading,
                                                })}
                                                onClick={() => {
                                                    handleReaction && handleReaction(ReactionType.Dislike);
                                                }}
                                            >
                                                {reaction?.dislike ? (
                                                    <DislikeFill style={{ width: 22 }} />
                                                ) : (
                                                    <BtnDislike style={{ width: 22 }} />
                                                )}
                                            </span>
                                        ) : null}
                                        {isEditable && !userName ? (
                                            <span
                                                className={styleItemStyles.actionsIcon}
                                                onClick={handleViewFeedbackByStylist}
                                            >
                                                <FeedBackView style={{ width: 22 }} />
                                            </span>
                                        ) : (!userDetail || isCustomer) && reaction?.dislike ? (
                                            <span
                                                className={styleItemStyles.actionsIcon}
                                                onClick={() =>
                                                    handleOpenFeedback(FEEDBACK_TRIGGER_TYPE.FEEDBACK, item?.collection)
                                                }
                                            >
                                                {feedback?.id ? (
                                                    <FeedBackView style={{ width: 22 }} />
                                                ) : (
                                                    <FeedBack style={{ width: 22 }} />
                                                )}
                                            </span>
                                        ) : null}
                                        {url?.length && (
                                            <span
                                                onClick={async () => {
                                                    setSharing && setSharing(true);
                                                    getShareImage && getShareImage();
                                                }}
                                                className={styleItemStyles.actionsIcon}
                                                style={{ color: themes.palette.primary.main }}
                                            >
                                                <BtnShare />
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <button
                                className={styleItemStyles.editOrAddButton}
                                disabled={userDetail?.userType === UserType.Stylist && !isEditable}
                                onClick={() => handleBottomButton()}
                            >
                                {userDetail?.userType === UserType.Stylist || isEditable ? (
                                    <>
                                        <EditStyle style={{ color: 'white', marginRight: 8 }} />
                                        {STRINGS.EDIT_ITEM}
                                    </>
                                ) : (
                                    <span
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        {STRINGS.SHOP_ITEM}
                                        {(utils.isAppInWidgetMode() ||
                                            item?.currency !== Currency.Sar ||
                                            config.removeCheckOut) && <OpenNewTab style={{ marginLeft: 8 }} />}
                                    </span>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </Drawer>
            {showEnlarge && <ZoomImage img={imageToEnlarge} setShowImage={setShowEnlarge} />}
            {showPopupInfo && (
                <WidgetPopup
                    titlePopup={'Item Information'}
                    widgetCode={WidgetCode.ViewStyleInfo}
                    infoItem={styleItemUtils.getInfo(item, 'widgetpop')}
                    onClose={() => setShowPopupInfo(false)}
                    pageCode="feed"
                    infoStyle={style}
                />
            )}
        </>
    );
};

export default DynamicLayoutItemDetail;
